import { render, staticRenderFns } from "./AttachVMWithName.vue?vue&type=template&id=4e59740c&"
import script from "./AttachVMWithName.vue?vue&type=script&lang=js&"
export * from "./AttachVMWithName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports